module.exports = __webpack_public_path__ + "a86b3e71d9687f91c638636fce8e572e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/event-create.png
// module id = 214
// module chunks = 0